import { render } from "./WorkspacesShowView.vue?vue&type=template&id=3af3c9b3"
import script from "./WorkspacesShowView.vue?vue&type=script&lang=js"
export * from "./WorkspacesShowView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__